jQuery(document).ready(function($){

    $('[data-copy]').click(function(event) {
        event.preventDefault();
        var text = $('[data-copy-source]').text();
        var $temp = $("<input>");
        $("body").append($temp);
        $temp.val(text).select();
        document.execCommand("copy");
        $temp.remove();

        var $parent = $(this).closest('div');
        $temp = $('<div style="display: none;"><div class="callout success">Skopiowano do schowka</div></div>');
        $parent.after($temp);
        $temp.fadeIn('fast');
    });

});
